import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=f4bd973e&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=ts"
export * from "./SideBar.vue?vue&type=script&lang=ts"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=f4bd973e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bd973e",
  null
  
)

export default component.exports